(() => {
  const rootSelector = '[data-header-quote-indicator]';
  const bubbleSelector = '[data-header-quote-count-bubble]';
  const countSelector = '[data-header-quote-count]';
  const labelSelector = '[data-header-quote-count-label]';

  function getQuoteDraft() {
    return window.Express?.quoteDraft || null;
  }

  function getQuoteLineCount() {
    const quoteDraft = getQuoteDraft();
    if (!quoteDraft || typeof quoteDraft.getDraft !== 'function') return 0;

    return (quoteDraft.getDraft()?.items || []).length;
  }

  function getCountLabel(count) {
    return count === 1 ? 'Quote request has 1 item' : `Quote request has ${count} items`;
  }

  function renderQuoteCount() {
    document.querySelectorAll(rootSelector).forEach((root) => {
      const bubble = root.querySelector(bubbleSelector);
      const count = root.querySelector(countSelector);
      const label = root.querySelector(labelSelector);
      const lineCount = getQuoteLineCount();

      if (!bubble || !count || !label) return;

      bubble.hidden = lineCount === 0;
      count.textContent = lineCount < 100 ? String(lineCount) : '';
      label.textContent = getCountLabel(lineCount);
    });
  }

  function handleStorage(event) {
    if (!event.key || event.key === 'express:quote-draft:v1') renderQuoteCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderQuoteCount);
  } else {
    renderQuoteCount();
  }

  document.addEventListener('quote-draft:updated', renderQuoteCount);
  window.addEventListener('storage', handleStorage);
})();
